/**
 * The user's last zoom level, shared by the document viewer and the
 * reference viewer, across documents and sessions. Parity with the PDFTron
 * viewer, which persisted "zoomLevel" the same way.
 */

var ZOOM_LEVEL_STORAGE_KEY = "paperviewZoomLevel";
var ZOOM_MODES = ["automatic", "fit-page", "fit-width"];

/**
 * Reads the stored zoom level: a zoom mode string or a numeric scale
 * factor. Returns null when nothing valid is stored.
 *
 * @returns {string|number|null}
 */
export function loadStoredZoomLevel() {
  var stored = localStorage.getItem(ZOOM_LEVEL_STORAGE_KEY);
  if (!stored) return null;

  if (ZOOM_MODES.indexOf(stored) !== -1) return stored;

  var numeric = parseFloat(stored);
  var isSaneScale = !isNaN(numeric) && numeric >= 0.1 && numeric <= 10;
  if (isSaneScale) return numeric;

  return null;
}

/**
 * Stores every zoom change of a viewer so the next document opens at it.
 *
 * @param {Object} zoomPlugin - the viewer's zoom plugin (provides())
 * @returns {Function} unsubscribe
 */
export function rememberZoomLevel(zoomPlugin) {
  // event.newZoom is the resulting scale factor; event.level is only the
  // base the request started from (zoomIn passes the previous level).
  return zoomPlugin.onZoomChange(function (event) {
    localStorage.setItem(ZOOM_LEVEL_STORAGE_KEY, String(event.newZoom));
  });
}
